<template>
    <div>
        <MainLayout>
            <h1>{{ $t('domain_domain_list') }}</h1>
            <input v-model="new_domain">
            <select v-model="new_status">
                <option v-for="(status,index) in statuses" v-bind:key="index" :value="status.id">{{ status.title }}</option>
            </select>
            <button v-on:click="addDomain" :title="$t('domain_hint_add')">{{ $t('general_add') }}</button>
            <table class="table">
                <thead>
                <tr>
                    <th>{{ $t('general_id') }}</th>
                    <th>{{ $t('domain_domain') }}</th>
                    <th>{{ $t('general_status') }}</th>
                    <th>{{ $t('general_option') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(domain,index) in domains" v-bind:key="index">
                    <td>{{ domain.id }}</td>
                    <td v-on:dblclick="goToEdit(domain.id,true)">
                        <span v-if="edit[domain.id]!==true">{{ domain.domain }}</span>
                        <input v-on:blur="editDomain(domain.id,domain)" :ref="'input_edit_'+domain.id" v-else-if="edit[domain.id]===true" v-model="domain.domain">
                    </td>
                    <td v-on:dblclick="goToEdit(domain.id,true)">
                        <select v-on:change="editDomain(domain.id,domain)" :ref="'input_edit_'+domain.id" v-model="domain.status">
                            <option v-for="(status,index) in statuses" v-bind:key="index" :value="status.id">{{ status.title}}</option>
                        </select>
                    </td>
                    <td>
                        <button v-on:click="goToEdit(domain.id,true)">{{ $t('general_edit') }}</button>
                        <button v-on:click="deleteDomain(domain.id)">{{ $t('general_delete') }}</button>
                    </td>
                </tr>
                </tbody>

                <div class="pagination">
                    <Pagination route_name="domain_list" :page="page" :on_page="on_page" :total_item="total_item"/>
                </div>
            </table>
        </MainLayout>
    </div>
</template>

<script>
    import MainLayout from '../components/MainLayout.vue';
    import Pagination from '../components/Pagination';
    import {bus} from '../main'
    import config from '../config'

    export default {
        name: 'DomainList',
        components: {
            MainLayout,
            Pagination,
        },
        data:function(){
            return {
                domains:[],
                statuses:[],
                new_domain:'',
                new_status:'',
                edit:[],
                on_page:15,
                total_item:0,
                page:1,
            }
        },
        methods: {
            loadDomains: function() {
                let offset=((this.on_page * this.page)-this.on_page);
                this.axios.get(config.API_URL+'domains?offset='+offset+'&limit='+this.on_page).then(response => {
                    this.domains = response.data.data;
                    this.total_item = parseInt(response.data.total);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            loadStatuses: function() {
                this.axios.get(config.API_URL+'domains/statuses').then(response => {
                    this.statuses = response.data.data;
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            addDomain(){
                this.axios.post(config.API_URL+'domains',new URLSearchParams({
                    domain: this.new_domain,
                    status: this.new_status,
                })).then(response => {
                    this.new_domain = '';
                    this.loadDomains();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            goToEdit(id){
                this.edit[id]=true;
                this.$forceUpdate();
            },
            editDomain(id , domain){
                this.axios.put(config.API_URL+'domains/'+id, new URLSearchParams(
                    domain
                )).then(response => {
                    this.edit[id]=false;
                    this.$forceUpdate();
                    bus.$emit('alert-success',response.data.message);
                }).catch(error => {
                    if(error.response.status===401){
                        bus.$emit('logout',true);
                    }else{
                        bus.$emit('alert-error',error.response.data.message);
                    }
                });
            },
            deleteDomain:function(id){
                if(confirm(this.$t('general_delete_question'))) {
                    this.axios.delete(config.API_URL + 'domains/' + id).then(response => {
                        this.loadDomains();
                        bus.$emit('alert-success', response.data.message);
                    }).catch(error => {
                        if (error.response.status === 401) {
                            bus.$emit('logout', true);
                        } else {
                            bus.$emit('alert-error', error.response.data.message);
                        }
                    });
                }
            },
        },
        mounted() {
            if(this.$route.params.page) this.page = parseInt(this.$route.params.page); else this.page = 1;
            this.loadDomains();
            this.loadStatuses();
        },
        beforeRouteUpdate(to,from,next){
            if(to.params.page) this.page = parseInt(to.params.page); else this.page = 1;
            this.loadDomains();
            this.loadStatuses();
            next();
        },
    }
</script>

<style scoped>
    .table{
        width: 100%;
    }
    .table th{
        text-align: left;
    }
    .table tr:hover{
        background-color: lightgray;
    }
</style>
